module.exports = new __parcel__URL__("5c57b2e2-f641-421e-a95f-65fcb47e409a.74fe7b12.woff2").toString();